"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (m) {
	return new Date(new Date().setMonth(new Date().getMonth() + m));
};